// extracted by mini-css-extract-plugin
export default {"video":"skeleton_video__oy4D9","loading":"skeleton_loading__lW4pZ"};